import { render, staticRenderFns } from "./MitBorrowKeyPage.vue?vue&type=template&id=35cd0f68&scoped=true"
import script from "./MitBorrowKeyPage.vue?vue&type=script&lang=js"
export * from "./MitBorrowKeyPage.vue?vue&type=script&lang=js"
import style0 from "./MitBorrowKeyPage.vue?vue&type=style&index=0&id=35cd0f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cd0f68",
  null
  
)

export default component.exports